import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './kpi.types';
import * as constants from './kpi.constants';

export const storeKpi = generateStoreResourceAction<types.IKpi>(constants.STORE_KPI);
export const clearKpi = generateClearResourceAction(constants.CLEAR_KPI);
